import { AccountData, Conversation, Follower } from "@markit/common.types";
import { memo, useMemo, useState } from "react";
import { Colors } from "../../../utils/colors";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/store";
import { ConversationItem } from "../../DisplayItem/ConversationItem";

type ConversationsSidebarPreviewProps = {
  conversationItem: Conversation;
  conversationIndex: number;
  fetchedConversationUserData: AccountData[];
  fetchedConversationFollowerData: Follower[];
  isSelectedItem: boolean;
  selectConversationMainView: (conversation: Conversation) => void;
  hoveredIndex: number | null;
  setHoveredIndex: (index: number | null) => void;
  onLocalConversationUpdate: (conversation: Conversation) => void;
};

const ConversationsSidebarPreview = (
  props: ConversationsSidebarPreviewProps
) => {
  const {
    conversationItem,
    conversationIndex,
    fetchedConversationUserData,
    fetchedConversationFollowerData,
    isSelectedItem,
    selectConversationMainView,
    hoveredIndex,
    setHoveredIndex,
    onLocalConversationUpdate,
  } = props;
  const customer = useSelector(
    (state: AppState) => state.account.accountData.customer
  );
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const participant = useMemo(
    () =>
      fetchedConversationUserData.find(
        (user) => user.uid === conversationItem.uid
      ),
    [conversationItem, fetchedConversationUserData]
  );

  const followerData = useMemo(
    () =>
      fetchedConversationFollowerData.find(
        (follower) => follower.uid === conversationItem.uid
      ),
    [conversationItem, fetchedConversationFollowerData]
  );

  const isHovered = useMemo(
    () => hoveredIndex === conversationIndex,
    [hoveredIndex, conversationIndex]
  );

  return (
    <div className="ColumnNormal">
      <div
        className="AlignedRow ConversationSidebarItem"
        style={{
          backgroundColor: isSelectedItem
            ? Colors.BLUE5
            : isHovered
            ? Colors.GRAY6
            : Colors.WHITE,
          pointerEvents:
            customer.state === "ACTIVE" || customer.state === "TRIAL"
              ? "all"
              : "none",
        }}
        onMouseEnter={() => setHoveredIndex(conversationIndex)}
        onMouseLeave={() => {
          setHoveredIndex(null);
          setIsOpenDropdown(false);
        }}
        onClick={() => selectConversationMainView(conversationItem)}
      >
        <ConversationItem
          item={conversationItem}
          participant={participant}
          followerData={followerData}
          isSelectedItem={isSelectedItem}
          isHovered={isHovered}
          isOpenDropdown={isOpenDropdown}
          setIsOpenDropdown={setIsOpenDropdown}
          onLocalConversationUpdate={onLocalConversationUpdate}
        />
      </div>
    </div>
  );
};

export default memo(ConversationsSidebarPreview);
